export default __webpack_public_path__ + "static/media/face-1.d85d07a1.jpg";